import global from "../../global.js";

const d3 = global.d3;

const ReferenceDebug = function(group) {
    const PN = 50; // points number

    const NB = 0, NA = 1, EB = 2, EA = 3;
    const SB = 4, SA = 5, WB = 6, WA = 7;
    const AB = 8;

    const test_line = [];

    const interpolate = d3.line().x((d) => d[0]).y((d) => d[1]).curve(d3.curveLinear);

    for (let d = NB; d <= AB; d++) {
        test_line[d] = d3.create("svg:path").attr("stroke", "#ff0").attr("stroke-width", 3).attr("fill", "none");
    }

    this.draw = (projection) => {
        var {A, B} = projection;
        var geo_interpolate = [];
        geo_interpolate[NB] = d3.geoInterpolate(B.EN, [B.E    , B.N + 1]);
        geo_interpolate[NA] = d3.geoInterpolate(A.EN, [A.E    , A.N + 1]);
        geo_interpolate[EB] = d3.geoInterpolate(B.EN, [B.E + 1, B.N    ]);
        geo_interpolate[EA] = d3.geoInterpolate(A.EN, [A.E + 1, A.N    ]);
        geo_interpolate[SB] = d3.geoInterpolate(B.EN, [B.E    , B.N - 1]);
        geo_interpolate[SA] = d3.geoInterpolate(A.EN, [A.E    , A.N - 1]);
        geo_interpolate[WB] = d3.geoInterpolate(B.EN, [B.E - 1, B.N    ]);
        geo_interpolate[WA] = d3.geoInterpolate(A.EN, [A.E - 1, A.N    ]);
        geo_interpolate[AB] = d3.geoInterpolate(B.EN, A.EN);
        for (let d = NB, p; d <= AB; d++) {
            p = Array.from(Array(PN + 1), (_, n) => n / PN);
            p = p.map(geo_interpolate[d]);
            p = p.map(projection.project);
            p = interpolate(p);
            test_line[d].attr("d", p);
            group.node().appendChild(test_line[d].node());
        }
    };

    this.undraw = () => {
        for (let d = NB; d <= AB; d++) {
            test_line[d].remove();
        }
    };
};

export default ReferenceDebug;
